// extracted by mini-css-extract-plugin
export default {"parent-container":"CreateUser_parent-container__CGc64","patient-list":"CreateUser_patient-list__uRc3-","newFormUsersOnly":"CreateUser_newFormUsersOnly__6hFzo"};